import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { TimerSvg } from '../Svgs';
import { formatTime } from '../../utility/Utils';
import './Timer.scss';

const TimerCounter = ({
  timeElapsed,
  totalTime,
  showEndTime,
  showWarning,
  hasControls,
  isRunning,
  timerControlChange,
}) => {
  const optionalEndTimeSuffix = showEndTime ? `/${formatTime(totalTime)}` : '';
  const classNames = cn(
    'Timer',
    {
      'Timer--warning': showWarning,
    },
    {
      'Timer--time__control': hasControls,
    },
  );

  /**
   * Shows or hides the timer
   * */
  const timerAction = () => {
    timerControlChange(!isRunning);
  };

  const hideTimer = hasControls && !isRunning && !showWarning;

  return (
    <div
      tabIndex={0}
      className={classNames}
      aria-label={
        hideTimer
          ? 'Show remaining time'
          : `Remaining time: ${formatTime(
              timeElapsed,
              true,
            )}${optionalEndTimeSuffix}`
      }
      role="button"
      onClick={hasControls && !showWarning ? timerAction : undefined}
    >
      <TimerSvg />
      <span className="Timer--time__count">
        {hideTimer
          ? 'Show'
          : `${formatTime(timeElapsed)}${optionalEndTimeSuffix}`}
      </span>
    </div>
  );
};

TimerCounter.propTypes = {
  timeElapsed: PropTypes.number,
  totalTime: PropTypes.number,
  showEndTime: PropTypes.bool,
  showWarning: PropTypes.bool,
  hasControls: PropTypes.bool,
  isRunning: PropTypes.bool,
  timerControlChange: PropTypes.func,
};

TimerCounter.defaultProps = {
  hasControls: false,
  isRunning: true,
  timerControlChange: () => {},
};

TimerCounter.displayName = 'TimerCounter';
export default TimerCounter;
